export const roleDefinitions = {
  owner: {
    id: 'owner',
    label: 'Propietario',
    description: 'Control total de la organización, negocios y sucursales.',
  },
  admin: {
    id: 'admin',
    label: 'Administrador',
    description: 'Gestiona la operación sin transferir la propiedad.',
  },
  supervisor: {
    id: 'supervisor',
    label: 'Supervisor',
    description: 'Supervisa ventas, caja, personal y reportes.',
  },
  cashier: {
    id: 'cashier',
    label: 'Cajero',
    description: 'Opera el punto de venta y su caja asignada.',
  },
  inventory: {
    id: 'inventory',
    label: 'Inventario',
    description: 'Controla productos, existencias y movimientos.',
  },
  accounting: {
    id: 'accounting',
    label: 'Contabilidad',
    description: 'Consulta y registra información administrativa.',
  },
  seller: {
    id: 'seller',
    label: 'Vendedor',
    description: 'Registra ventas y consulta su operación.',
  },
  viewer: {
    id: 'viewer',
    label: 'Solo lectura',
    description: 'Consulta información sin modificarla.',
  },
} as const;

export type RoleId = keyof typeof roleDefinitions;

export const permissions = [
  'costs.read',
  'profits.read',
  'discounts.apply',
  'sales.cancel',
  'cash.open',
  'cash.close',
  'expenses.create',
  'inventory.adjust',
  'inventory.transfer',
  'reports.read',
  'team.manage',
  'settings.manage',
] as const;

export type PermissionId = (typeof permissions)[number];

export const permissionLabels: Record<PermissionId, string> = {
  'costs.read': 'Ver costos',
  'profits.read': 'Ver ganancias',
  'discounts.apply': 'Aplicar descuentos',
  'sales.cancel': 'Cancelar ventas',
  'cash.open': 'Abrir caja',
  'cash.close': 'Cerrar caja',
  'expenses.create': 'Registrar gastos',
  'inventory.adjust': 'Modificar inventario',
  'inventory.transfer': 'Transferir productos',
  'reports.read': 'Ver reportes',
  'team.manage': 'Administrar empleados',
  'settings.manage': 'Cambiar configuración',
};

const allPermissions = [...permissions];
export const rolePermissions: Record<RoleId, PermissionId[]> = {
  owner: allPermissions,
  admin: allPermissions,
  supervisor: ['costs.read', 'profits.read', 'discounts.apply', 'sales.cancel', 'cash.open', 'cash.close', 'expenses.create', 'inventory.adjust', 'inventory.transfer', 'reports.read'],
  cashier: ['discounts.apply', 'cash.open', 'cash.close'],
  inventory: ['costs.read', 'inventory.adjust', 'inventory.transfer'],
  accounting: ['costs.read', 'profits.read', 'expenses.create', 'reports.read'],
  seller: ['discounts.apply'],
  viewer: ['reports.read'],
};

export const hasPermission = (role: RoleId, permission: PermissionId) => rolePermissions[role].includes(permission);
